<template>

    <div>

        <div class="container">

            <div class="breadcrumbs">
                <ul>
                    <li>
                        <a href="#" @click="getSoundClick(); $router.go(-1)">
                            <i class="lisa-icon-back"></i>
                        </a>
                    </li>
                    <li>
                        <div class="btn-group nav" role="tablist">
                            <router-link :to="{path: '/daily-challenge'}" @click.native="getSoundClick">
                                <button class="btn btn-primary" id="nav-avatar-tab">{{ $t('daily_challenge') }}</button>
                            </router-link>
                            <button class="btn btn-primary active" id="nav-emoticon-tab">{{ $t('daily_bonus') }}</button>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="tab-content">
                <div class="tab-pane fade show active" id="nav-avatar" role="tabpanel" aria-labelledby="nav-avatar-tab">

                </div>
                <div class="tab-pane fade show active" id="nav-emoticon" role="tabpanel" aria-labelledby="nav-emoticon-tab">

                    <div class="card card-daily-challenge">
                        <div class="card-header">
                            <div class="card-title"> {{ $t('daily_bonus') }}</div>
                        </div>
                        <div class="card-body">
                            <div class="d-flex">
                                <div class="flex">
                                    <div>{{ $t('daily_bonus_1') }}</div>
                                </div>
                                <div>
                                    {{ $t('daily_bonus_2') }}: <b style="font-size: 16px;">{{ time_next_bonus_txt }}</b>
                                </div>
                            </div>
                            <div class="daily-bonus" style=";height: 370px; overflow-x: auto;">
                                <template v-for="(bonus, index) in bonuses">
                                    <daily-bonus-item :bonus="bonus" :today_id="today_id" />
                                </template>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- <div class="modal fade modal-flex" id="dailyBonusModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="dailyBonusModal" aria-hidden="true">
                <div class="modal-dialog" style="width: 539px; max-width: 539px;">
                    <div class="modal-content" style="padding-bottom: 15px;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="staticBackdropLabel">{{$t('daily_bonus')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="daily-bonus">
                                <div class="daily-bonus-gem">
                                    <div class="text-1">{{ $t(user_info.dailybonus_dayname) }}</div>
                                    <div class="gem">
                                        <i class="lisa-icon-gem-large"></i>
                                    </div>
                                    <div class="text-2">+{{ user_info.dailybonus_gemreward }}</div>
                                </div>
                                <div class="daily-bonus-content">
                                    {{$t('daily_bonus_msg')}}
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="claim" type="button" class="btn btn-main-border m-auto" style="padding: 8px 15px;">{{$t('claim')}}</button>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>

</template>

<script>
    import {updateProfile} from '../../models/profile'
    import {showDialog} from '../../utils/dialog'
    import {mapGetters} from 'vuex'
    import axios from "axios";
    import {getDailyBonus, getDailyChallenge} from "../../models/reward";
    import DailyBonusItem from "./DailyBonusItem";
    import {convertSecondToText, soundClick} from "../../utils/utils";
    import {claimDailyBonus} from "../../models/reward";

    export default {
        name: "DailyBonus",
        components: {DailyBonusItem},
        title: 'Daily bonus',

        data() {
            return {
                bonuses: '',
                today_id: '',
                time_next_bonus: '',
                time_next_bonus_txt: '',
            };
        },

        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }

                return this.user
            })
        },

        created() {
            this.fetch();
        },

        watch: {
            time_next_bonus: {
                handler(value) {

                    if (value > 0) {
                        setTimeout(() => {
                            this.time_next_bonus--;

                            this.time_next_bonus_txt = convertSecondToText(this.time_next_bonus) || '';
                        }, 1000);
                    }

                },
                immediate: true // This ensures the watcher is triggered upon creation
            }

        },

        methods: {
            async fetch() {
                const that = this;

                await axios.all([
                    getDailyBonus(),
                ]).then(axios.spread((response) => {
                    that.isLoading = false;

                    if (response.data.code != 0) {
                        return;
                    }

                    that.bonuses = response.data.results.daily_bonus || [];
                    that.today_id = response.data.results.today_id || '';
                    that.time_next_bonus = response.data.results.time_next_bonus || 0;
                    that.time_next_bonus_txt = convertSecondToText(that.time_next_bonus) || '';

                    console.log(that.bonuses );
                }));
            },

            claim() {
                const that = this;

                that.getSoundClick();

                that.$store.commit("setLoading", true);

                claimDailyBonus().then((response) => {
                    that.$store.commit("setLoading", false);

                    //if (response.data.code != 0) {
                    //  return;
                    //}

                    //that.bonus.status = response.data.results.status || '';

                    const gem_reward = response.data.results.gem_reward || 0;
                    const new_gem = response.data.results.update_gem || 0;

                    that.user_info.gem = new_gem;

                    const gem_txt = gem_reward >= 0 ? '+' + gem_reward : '-' + gem_reward;

                    //that.getSoundClaimTreasure();

                    $('#congratulation_gem').text(gem_txt);
                    $('#dailyBonusModal').modal("hide");
                    $('#getRewardedModal').modal();
                    this.$emit('updateFirstLogin', 0)
                }).catch((response) => {
                    that.$store.commit("setLoading", false);

                    console.error(response);
                });
            },

            getSoundClick() {
                soundClick();
            },

        }
    }
</script>

<style scoped>
   /* .container{
        width: 940px;
        padding: 0;
    } */
    .card-body{
        padding-bottom: 50px;
    }
    .daily-bonus{
        align-items: flex-start !important;
    }
</style>
